import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default function toggleMenu() {
  let button = $('.header__burger');
  let menu = $('.header__mobmenu');
  let header = $('.header');
  let items = $('.header__logo, .footer__link');
  button.on('click', function() {
    if ($(this).hasClass('active')) {
      menu.removeClass('active');
      header.removeClass('active');
      enablePageScroll();
      $(this).removeClass('active');
    } else {
      menu.addClass('active');
      header.addClass('active');
      disablePageScroll();
      $(this).addClass('active');
    }
  });
  Array.from(items).forEach((item) => {
    $(item).on('click', function() {
      setTimeout(function() {
        button.removeClass('active');
        menu.removeClass('active');
        header.removeClass('active');
        enablePageScroll();
      }, 300);
    });
  });
  $(window).on('resize', function() {
    if ($(window).width() >= 768 && button.hasClass('active')) {
      button.removeClass('active');
      header.removeClass('active');
      menu.removeClass('active');
      enablePageScroll();
    }
  });
}
toggleMenu();